import { render, staticRenderFns } from "./TaskPage.vue?vue&type=template&id=7842516a&"
import script from "./TaskPage.vue?vue&type=script&lang=js&"
export * from "./TaskPage.vue?vue&type=script&lang=js&"
import style0 from "./TaskPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports